import React, {Component} from 'react';
import {histogram} from './histogram'
import HistogramPanel from './HistogramPanel'

export default class BatteryHistogram extends Component {
  constructor(props) {
    super(props);

    this.bins = [];
    this.onClick = this.onClick.bind(this)
  }

  batteryHistogramBins() {
    return [2.0, 2.2, 2.4, 2.6, 2.8, 3.0, 3.2];
  }
  batteryHistogramColors() {
    return ["#ff2c55", "#f57703", "#f57703", "#f1d900","#f1d900", "#0fc0a4", "#0fc0a4"];
  }

  batteryHistogram () {
    const bins = this.batteryHistogramBins();
    let volts = [];
    if (Array.isArray(this.props?.data)) {
      this.props.data.forEach(row => volts.push(row.BattVolt));
      return histogram (volts, bins);
    }
    return null;
  }

  onClick (param) {
    if (param.length) {  // apply filter
      const [{index}] = param
      this.props?.histoFilter && this.props.histoFilter (this.bins, index) 
    }
    else {     //clear filter
      this.props?.histoFilter && this.props.histoFilter (this.bins, -1) 
    }
  }

  render() {
    const gram = this.batteryHistogram()
    let bins = this.batteryHistogramBins()
    let hcolors = this.batteryHistogramColors()
    if (gram && gram.length > bins.length) {
      bins.unshift('NA')
      hcolors.unshift('#808080')
    }
    this.bins = bins
    return (
      <div className="histogram-single">
      <div className="histogram-title">MDT Battery Voltage at a Glance</div>
      <HistogramPanel {...this.props}  series1={gram} 
            label={bins} colors={hcolors} onClick={this.onClick} />
      </div>
    )
  }
}